import { CheckboxInput } from "@/components/Base/CheckboxInput";
import { Separator } from "@/components/Base/Separator";
import { CardFields } from "@/components/Settings/Cards/CardFields";
import { useMemo } from "react";
import { CardContents, Shop } from "@/types/v2";
import { DEFAULT_CARD_LABEL_WRAP } from "@/lib/const";
import { CheckedState } from "@radix-ui/react-checkbox";
import { shop as shopRepository } from "@/repositories/shop";
import { showSuccessToast } from "@/lib/toast";
import { updateCardContents } from "@/lib/shop";

type CardLayoutSettingsProps = {
  shopData: Shop;
};

export const CardLayoutSettings = ({ shopData }: CardLayoutSettingsProps) => {
  const shopId = useMemo(() => shopData.id, [shopData]);

  const cardLabelWrap = useMemo(
    () => shopData?.cardLabelWrap ?? DEFAULT_CARD_LABEL_WRAP,
    [shopData]
  );

  const handleLabelWrapClick = (newSelection: CheckedState) => {
    if (!shopId || !cardLabelWrap) return;

    shopRepository
      .updateCardLabelWrap(shopId, newSelection ? "yes" : "no")
      .then(() => {
        showSuccessToast(
          "Card Label Wrap Updated",
          "Return to the dashboard to see the updated card label wrap."
        );
      });
  };

  const handleCardContentsChange = (values: Partial<CardContents>) => {
    if (!shopData) return;
    return updateCardContents(shopData, values);
  };

  return (
    <div className="flex flex-col gap-4">
      <CheckboxInput
        value={cardLabelWrap}
        aria-label={"Wrap Card Labels"}
        label={"Wrap Card Labels"}
        checked={cardLabelWrap === "yes"}
        onCheckedChange={(checked) => handleLabelWrapClick(checked)}
      />
      <Separator />
      <CardFields shop={shopData} onSubmit={handleCardContentsChange} />
    </div>
  );
};
